<template>
    <div class="progress flex justify-between items-center">
        <div class="boxes flex items-center">
            <div v-for="index in total" :key="index"
                 class="box"
                :class="{'box--active': index === current, 'box--passed-correct': index < current && isCorrect(index), 'box--passed-incorrect': index < current && !isCorrect(index)}">
            </div>
        </div>
        <div class="text">{{ current }}/{{ total }}</div>
    </div>
</template>

<script>
import User from "../Modules/User";

export default {
	name: "Progress",
	props: {
		total: Number,
		current: Number,
		user: User,
	},
	computed: {
		complete() {
			return this.current / (this.total || 1) * 100;
		}
	},
	methods: {
		isCorrect(index) {
			return this.user.answers[index - 1].is_correct;
		}
	}
};
</script>

<style scoped lang="scss">
.progress {
    --border-radius: 0px 25px 25px 0px;
    --border: 2px solid #000000;
    --padding: 7px 24px;
    --margin: 60px 20px 20px 0;
    --box-size: 8px;
    --box-gap: 10px;
    --text-size: 12px;

    @media (min-width: 1024px) {
        --border-radius: 30px;
        --border: 4px solid #000000;
        --padding: 18px 38px;
        --margin: 60px 0 20px;
        --box-size: 12px;
        --box-gap: 20px;
        --text-size: 16px;
    }

    position: relative;
    z-index: 4;
    padding: var(--padding);
    margin: var(--margin);
    border: var(--border);
    border-radius: var(--border-radius);
    background: white;

    .boxes {
        gap: var(--box-gap);
        .box {
            width: var(--box-size);
            height: var(--box-size);
            background: var(--lightest-purple);

            &.box--active {
                background: var(--light-blue);
            }
            &.box--passed-correct {
                background: var(--green);
            }
            &.box--passed-incorrect {
                background: var(--red);
            }
        }
    }
    .text {
        font-weight: 900;
        font-size: var(--text-size);
    }

}
</style>
